import { useState, useEffect } from 'react';

const TOPUP_PASSWORD = 'rpt@676875';
const SESSION_KEY = 'topup_auth_session';

/**
 * Custom hook for topup password authentication
 * Stores authentication state in sessionStorage
 * Password persists across page reloads but clears on tab close
 */
export function useTopupAuth() {
  const [isPasswordAuthenticated, setIsPasswordAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check session on component mount
  useEffect(() => {
    const session = sessionStorage.getItem(SESSION_KEY);
    if (session === 'authenticated') {
      setIsPasswordAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  /**
   * Validate password and set session if correct
   * @param password - User-entered password
   * @returns true if password matches, false otherwise
   */
  const validatePassword = (password: string): boolean => {
    const isValid = password === TOPUP_PASSWORD;
    if (isValid) {
      sessionStorage.setItem(SESSION_KEY, 'authenticated');
      setIsPasswordAuthenticated(true);
    }
    return isValid;
  };

  /**
   * Clear session (logout from topup page)
   */
  const clearSession = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setIsPasswordAuthenticated(false);
  };

  return {
    isPasswordAuthenticated,
    isLoading,
    validatePassword,
    clearSession
  };
}
